﻿import { booking_information_token } from "./booking_information_token";

export class booking_information {
    affiliate_app_id: string | null = null;
    affiliate_contact: string | null = null;
    iso_currency_code: string | null = null;
    booking_reference: string | null = null;
    token: booking_information_token = new booking_information_token();
}